import axios from 'axios';
// import store from '../store';
import moment from 'moment';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'installmentkredit';
const keys = ['page', 'limit', 'sortBy', 'sortDir','tgl1','tgl2','angsuran1','angsuran2','collector_id','no_kontrak','sourceproject','customer','outstand','nasabahkey',"wo_status"];
export default {
    list(obj){
        return new Promise(async(resolve,reject)=>{
            try {
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve({list,total:meta.total});
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxls(obj){
        return new Promise(async(resolve,reject)=>{
            try {
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `angsuran-${moment().format('YYYYMM')}.xlsx`);
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getlastangsuranloan(obj){
        return new Promise(async(resolve,reject)=>{
            try {
                const url = `/${baseurl}/get-last-angsuran-loan/${obj.pinjamankey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    getangsuranOSDue(obj){
        return new Promise(async(resolve,reject)=>{
            try {
                const url = `/${baseurl}/get-angsuran-os-due/${obj.pinjamankey}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
}